import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const sell_InvoiceApi = createAsyncThunk("sell_Invoice", async ({ startDate = null, endDate = null }) => {
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  const response = await axiosInstance.get("/sell_Invoice",{ params });
  return response.data;
});

const sell_InvoiceSlice = createSlice({
  name: "sell_Invoice",
  initialState: {
    sell_Invoice: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sell_InvoiceApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(sell_InvoiceApi.fulfilled, (state, action) => {
        state.sell_Invoice = action.payload;
        state.loading = false;
      })
      .addCase(sell_InvoiceApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sell_InvoiceSlice.reducer;
